// extracted by mini-css-extract-plugin
module.exports = {"sideBar":"SideBar_sideBar__3q1fM","tabs":"SideBar_tabs__3BwmF","tab":"SideBar_tab__2zO1A"};